export default {"src":"/_next/static/media/burger_menu.7ec4ad86.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};